/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TestStore, TestStoreInterface } from "../TestStore";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "asset",
        type: "bytes32",
      },
    ],
    name: "AssetStored",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_assetsStored",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "asset",
        type: "bytes32",
      },
    ],
    name: "store",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "asset",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "depositorCheck",
        type: "address",
      },
    ],
    name: "storeWithDepositor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b506102ec806100206000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c8063654cf88c1461004657806396add6001461005b578063ea287d1514610092575b600080fd5b610059610054366004610245565b6100a5565b005b61007e610069366004610245565b60006020819052908152604090205460ff1681565b604051901515815260200160405180910390f35b6100596100a036600461027a565b610146565b60008181526020819052604090205460ff16156101035760405162461bcd60e51b8152602060048201526017602482015276185cdcd95d081a5cc8185b1c9958591e481cdd1bdc9959604a1b60448201526064015b60405180910390fd5b600081815260208190526040808220805460ff191660011790555182917f08ae553713effae7116be03743b167b8b803449ee8fb912c2ec43dc2c824f53591a250565b60008281526020819052604090205460ff161561019f5760405162461bcd60e51b8152602060048201526017602482015276185cdcd95d081a5cc8185b1c9958591e481cdd1bdc9959604a1b60448201526064016100fa565b806001600160a01b0316836001600160a01b0316146102005760405162461bcd60e51b815260206004820152601960248201527f696e76616c6964206465706f7369746f7220616464726573730000000000000060448201526064016100fa565b600082815260208190526040808220805460ff191660011790555183917f08ae553713effae7116be03743b167b8b803449ee8fb912c2ec43dc2c824f53591a2505050565b60006020828403121561025757600080fd5b5035919050565b80356001600160a01b038116811461027557600080fd5b919050565b60008060006060848603121561028f57600080fd5b6102988461025e565b9250602084013591506102ad6040850161025e565b9050925092509256fea2646970667358221220cd0dd11efb77ab667b666fa499d316a732b855b1991b22725923ce016cffdfb664736f6c634300080b0033";

type TestStoreConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestStoreConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestStore__factory extends ContractFactory {
  constructor(...args: TestStoreConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "TestStore";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TestStore> {
    return super.deploy(overrides || {}) as Promise<TestStore>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): TestStore {
    return super.attach(address) as TestStore;
  }
  connect(signer: Signer): TestStore__factory {
    return super.connect(signer) as TestStore__factory;
  }
  static readonly contractName: "TestStore";
  public readonly contractName: "TestStore";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestStoreInterface {
    return new utils.Interface(_abi) as TestStoreInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestStore {
    return new Contract(address, _abi, signerOrProvider) as TestStore;
  }
}
